// @flow
import { addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import 'url-search-params-polyfill';

// This contains what `react-intl` needs for all versions of English
// so it's loaded upfront as our default is UK English.
addLocaleData(en);

export function initializePolyfills() {
    return Promise.all([polyfillIntl()]);
}

function polyfillIntl() {
    return new Promise((resolve, reject) => {
        if ('Intl' in global) {
            return resolve();
        }

        require.ensure([], require => {
            require('intl');
            require('intl/locale-data/jsonp/en-GB.js');

            resolve();
        });
    });
}



// WEBPACK FOOTER //
// ./src/polyfills.js